import script from "./cylinderComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./cylinderComponent.vue?vue&type=script&setup=true&lang=js"

import "./cylinderComponent.vue?vue&type=style&index=0&id=5aa3beca&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aa3beca"]])

export default __exports__